import 'waypoints/lib/jquery.waypoints.js';
import 'waypoints/lib/shortcuts/sticky.js';
import './waypoint.scss';
import './front.scss';

const $revealers = document.querySelectorAll(
	`.js-grist-reveal-card-revealer`
);

if ( $revealers ) {
	$revealers.forEach( ( $revealer, index ) => {
		const $button = $revealer.querySelector(
			`.js-grist-reveal-card-revealer-button`
		);
		const $inner = $revealer.querySelector(
			`.js-grist-reveal-card-revealer-inner`
		);
		const expandId = `expand_${ index + 1 }`;
		const openLabel = $button.textContent;
		const closeLabel = $button.dataset?.closeLabel
			? $button.dataset?.closeLabel
			: 'Close';

		$button.setAttribute( 'aria-expanded', `false` );
		$button.setAttribute( 'aria-controls', expandId );
		$inner.setAttribute( 'id', expandId );
		$button.setAttribute( 'aria-labelledby', expandId );

		const toggle = () => {
			const isExpanded =
				$button.getAttribute( 'aria-expanded' ) == 'true';
				$button.setAttribute( 'aria-expanded', ! isExpanded );
			  	$button.textContent = isExpanded ? openLabel : closeLabel;
			  	$revealer.previousElementSibling.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
			  	Waypoint.refreshAll();
		};

		$button.addEventListener( 'click', toggle );
	} );
}

function reSortCards( selectedTag, $cards ) {
	$cards.forEach( ( $card ) => {
		const $tag = $card.dataset.category;

		if ( '' !== $tag ) {
			const tagText = $tag.toLowerCase()
				.replace(/ /g, '-')
				.replace(/[^\w-]+/g, '');

			if ( tagText === selectedTag ) {
				$card.classList.add( 'grist-reveal-card--top' );
			} else {
				$card.classList.remove('grist-reveal-card--top');
			}
    	}
  } );
}

const $topBar = document.querySelector( `.g-top-bar` );
const $sortingContainer = document.querySelector(
	`.js-grist-reveal-sorting-container`
);

if ( null !== $sortingContainer ) {
	const $cards = document.querySelectorAll(`.grist-reveal-card`);
	const $stickyWrapper = $sortingContainer.querySelector(`.sticky-wrapper`);
	let stickyOffset = 0;
	const $selectControl = document.querySelector(
		`.grist-reveal-card-select-sort`
	);

	if ($topBar) {
		const rect = $topBar.getBoundingClientRect();
		stickyOffset = rect ? rect.top + rect.height : 0;
	}

	if (Waypoint) {
		new Waypoint.Sticky({
			element: $stickyWrapper,
			stuckClass: 'gp-filter--fixed',
			offset: stickyOffset,
		});
		Waypoint.refreshAll();
	}

	if ($selectControl) {
		$selectControl.addEventListener('change', (event) => {
			reSortCards(
				event.target.value.toLowerCase(),
				$cards
			);
			$sortingContainer.scrollIntoView();
			Waypoint.refreshAll();
		});
	}
}
